/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { TaskItemAreaDto } from './TaskItemAreaDto';
import {
    TaskItemAreaDtoFromJSON,
    TaskItemAreaDtoFromJSONTyped,
    TaskItemAreaDtoToJSON,
} from './TaskItemAreaDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface TaskItemDto
 */
export interface TaskItemDto {
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskItemDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskItemDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TaskItemDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TaskItemDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskItemDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof TaskItemDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof TaskItemDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof TaskItemDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof TaskItemDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof TaskItemDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof TaskItemDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof TaskItemDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskItemDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof TaskItemDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {StateOfUse}
     * @memberof TaskItemDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<TaskItemAreaDto>}
     * @memberof TaskItemDto
     */
    taskItemAreas?: Array<TaskItemAreaDto> | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof TaskItemDto
     */
    category?: RtSystemCategory;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof TaskItemDto
     */
    subCategory?: MedicalSystemSubCategory;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof TaskItemDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    $type?: TaskItemDtoTypeEnum;
}


/**
 * @export
 */
export const TaskItemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoTaskItemDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.TaskItemDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TaskItemDtoTypeEnum = typeof TaskItemDtoTypeEnum[keyof typeof TaskItemDtoTypeEnum];



/**
 * Check if a given object implements the TaskItemDto interface.
 */
export function instanceOfTaskItemDto(value?: unknown): value is TaskItemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskItemDtoTypeEnum)[0];
}

export function TaskItemDtoFromJSON(json: any): TaskItemDto {
    return TaskItemDtoFromJSONTyped(json, false);
}

export function TaskItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': json['state'] == null ? undefined : StateOfUseFromJSON(json['state']),
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'taskItemAreas': json['taskItemAreas'] == null ? undefined : ((json['taskItemAreas'] as Array<any>).map(TaskItemAreaDtoFromJSON)),
        'category': json['category'] == null ? undefined : RtSystemCategoryFromJSON(json['category']),
        'subCategory': json['subCategory'] == null ? undefined : MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'taskType': json['taskType'] == null ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TaskItemDtoToJSON(value?: Omit<TaskItemDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'editingUser': UserCatalogDtoToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': StateOfUseToJSON(value['state']),
        'name': value['name'],
        'iuid': value['iuid'],
        'description': value['description'],
        'taskItemAreas': value['taskItemAreas'] == null ? undefined : ((value['taskItemAreas'] as Array<any>).map(TaskItemAreaDtoToJSON)),
        'category': RtSystemCategoryToJSON(value['category']),
        'subCategory': MedicalSystemSubCategoryToJSON(value['subCategory']),
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        '$type': value['$type'],
    });
}

